.welcomeScreenBody {
  padding-bottom: 20px;
}

.inputError {
  color: var(--colorDanger);
}

.welcomeScreenSection {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
}
.welcomeScreenSection .welcomeScreenImage {
  width: 100%;
}
.welcomeScreenSection .welcomeScreenIcon {
  width: 96px;
  height: 96px;
  border-radius: 22%;
}
.welcomeScreenSection .welcomeScreenTitle {
  color: var(--colorNone);
  font-size: x-large;
  margin-bottom: 0px;
  margin-top: 10px;
}
@media (max-height: 720px) {
  .welcomeScreenSection {
    margin-bottom: 15px;
  }
  .welcomeScreenSection .welcomeScreenImage {
    width: 30vh;
  }
  .welcomeScreenSection .welcomeScreenIcon {
    width: 72px;
    height: 72px;
  }
  .welcomeScreenSection .welcomeScreenTitle {
    margin-top: 8px;
  }
}

.welcomeScreenButtonGroup {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 40px;
}
@media (max-height: 720px) {
  .welcomeScreenButtonGroup {
    margin-top: 20px;
  }
}

.welcomeScreenButton {
  letter-spacing: 0.25px;
  margin: 7px 0;
  width: 100%;
}

.welcomeScreenFooterLinks {
  text-align: center;
  width: 100%;
}

.instantOnboardingAgreement {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 10px;
  width: 100%;
}

.openExternalIcon {
  background-color: var(--buttonSecondaryText);
  margin-inline-start: 0.2em;
}

.relayPicker {
  margin: 4px 0 14px;
  position: relative;
  text-align: left;
  width: 100%;
}

.relayPickerLabel {
  color: var(--deltaChatPrimaryFgLight);
  display: block;
  font-size: 13px;
  margin-bottom: 2px;
}

.relayPickerTrigger {
  align-items: center;
  appearance: none;
  background: none;
  border: none;
  border-bottom: 1px solid var(--deltaChatPrimaryFgLight);
  color: var(--bp4InputText);
  cursor: pointer;
  display: flex;
  font-size: 16px;
  gap: 10px;
  justify-content: space-between;
  padding: 8px 2px;
  width: 100%;
}
.relayPickerTrigger:hover .relayPickerTriggerAction {
  text-decoration: underline;
}
.relayPickerTrigger:focus {
  border-bottom-color: var(--loginInputFocusColor);
  outline: none;
}

.relayPickerTriggerValue {
  align-items: baseline;
  display: flex;
  gap: 6px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.relayPickerTriggerAction {
  color: var(--loginInputFocusColor);
  flex: none;
  font-size: 14px;
}

.relayPickerDefaultTag {
  color: var(--deltaChatPrimaryFgLight);
  flex: none;
  font-size: 11px;
  font-weight: 400;
  opacity: 0.8;
}

.relayDialogList {
  display: flex;
  flex-direction: column;
  margin: 0 -12px;
}

.relayDialogRow {
  align-items: center;
  appearance: none;
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  display: flex;
  font-size: 15px;
  gap: 12px;
  justify-content: space-between;
  padding: 11px 16px;
  text-align: left;
  width: 100%;
}
.relayDialogRow:hover, .relayDialogRow:focus {
  background: var(--globalHoverBg);
  outline: none;
}

.relayDialogRowSelected {
  font-weight: 600;
}

.relayDialogRowDisabled {
  cursor: default;
  opacity: 0.55;
}
.relayDialogRowDisabled:hover, .relayDialogRowDisabled:focus {
  background: none;
}

.relayDialogHost {
  align-items: baseline;
  display: flex;
  gap: 6px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.relayDialogCheck {
  color: var(--loginInputFocusColor);
  flex: none;
}

.relayDialogDefaultTag {
  color: var(--deltaChatPrimaryFgLight);
  flex: none;
  font-size: 11px;
  font-weight: 400;
  opacity: 0.8;
}

.relayDialogLatency {
  align-items: center;
  color: var(--deltaChatPrimaryFgLight);
  display: flex;
  flex: none;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  gap: 6px;
}

.relayDialogDot {
  border-radius: 50%;
  flex: none;
  height: 8px;
  width: 8px;
}

.relayDialogDotGood {
  background: #3ba55d;
}

.relayDialogDotOkay {
  background: #d9a441;
}

.relayDialogDotSlow {
  background: var(--colorDanger);
}

.relayDialogUnreachable {
  color: var(--colorDanger);
  flex: none;
  font-size: 12px;
  opacity: 0.9;
}

.relayDialogPing {
  flex: none;
  height: 18px;
  position: relative;
  width: 18px;
}
.relayDialogPing::before {
  background: var(--deltaChatPrimaryFgLight);
  border-radius: 50%;
  content: "";
  height: 4px;
  left: 50%;
  margin: -2px 0 0 -2px;
  position: absolute;
  top: 50%;
  width: 4px;
}

.relayDialogPingRing {
  animation: relayDialogSonar 1.4s ease-out infinite;
  border: 1.5px solid var(--deltaChatPrimaryFgLight);
  border-radius: 50%;
  inset: 0;
  position: absolute;
}
.relayDialogPingRing:nth-child(2) {
  animation-delay: 0.7s;
}

@keyframes relayDialogSonar {
  0% {
    opacity: 0.7;
    transform: scale(0.2);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}
.relayContactSection {
  border-top: 1px solid var(--separatorColor);
  margin-top: 12px;
  padding-top: 8px;
}

.relayContactHeader {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 4px 4px 0;
}

.relayContactTitle {
  color: var(--deltaChatPrimaryFgLight);
  font-size: 13px;
}

.relayContactMeasure {
  appearance: none;
  background: none;
  border: none;
  color: var(--loginInputFocusColor);
  cursor: pointer;
  flex: none;
  font-size: 14px;
  padding: 4px;
}
.relayContactMeasure:disabled {
  cursor: default;
  opacity: 0.55;
}

.relayContactHint {
  color: var(--deltaChatPrimaryFgLight);
  font-size: 12px;
  margin: 2px 4px 6px;
  opacity: 0.8;
}

.relayDialogOther {
  appearance: none;
  background: none;
  border: none;
  color: var(--loginInputFocusColor);
  cursor: pointer;
  font-size: 14px;
  margin-block: 12px 8px;
  padding: 4px 4px;
  text-align: left;
}

.relayDialogCustomRow {
  align-items: center;
  display: flex;
  gap: 10px;
  margin-block: 12px;
}

.relayDialogCustomInput {
  background: none;
  border: none;
  border-bottom: 1px solid var(--deltaChatPrimaryFgLight);
  color: var(--bp4InputText);
  flex: 1;
  font-size: 15px;
  min-width: 0;
  padding: 6px 0;
}
.relayDialogCustomInput:focus {
  border-bottom-color: var(--loginInputFocusColor);
  outline: none;
}

.relayDialogCustomInputError {
  border-bottom-color: var(--colorDanger);
}

.relayDialogCustomConfirm {
  background: none;
  border: none;
  color: var(--loginInputFocusColor);
  cursor: pointer;
  flex: none;
  font-size: 15px;
  font-weight: 600;
  padding: 6px 8px;
}